import { observer } from 'mobx-react-lite';
import { useEsriMapStore } from '../../../hooks/use-esri-map-store';
import { PhoneCallOverview } from './phone-call-overview';
import { usePhoneCallsStore } from '../../../../phone-calls/use-phone-calls';
import { LocationAddressAndGpsSection } from '../location-address-and-gps-section';
import { PanelWrapper } from '../panel-wrapper';
import { PhoneCallInfo } from './phone-call-info';
import { useApplicationType } from '../../../../common/hooks/use-application-type';

export const PhoneCallPanel = observer(function PhoneCallPanel(): React.ReactElement | null {
    const { selectedPhoneCallId, phoneCallEntity } = useEsriMapStore();

    const phoneCallsStore = usePhoneCallsStore();

    const { isFirstResponder } = useApplicationType();
    const size = isFirstResponder ? 'lg' : 'md';

    if (!selectedPhoneCallId) return null;

    const selectedPhoneCall = phoneCallsStore.getPhoneCall(selectedPhoneCallId) || phoneCallEntity;

    if (!selectedPhoneCall) return null;

    return (
        <PanelWrapper testId="PHONE_CALL_PANEL">
            <PhoneCallOverview
                label={selectedPhoneCall.labelPrefix}
                createdDateUtc={selectedPhoneCall.createdDateUtc}
                classOfService={selectedPhoneCall.classOfService}
                size={size}
            />
            <LocationAddressAndGpsSection
                isGpsLocation
                placeName={selectedPhoneCall.normalizedPhoneCallDisplay.callerAddressDisplay}
                areGpsLocationCoordinatesVerified={
                    selectedPhoneCall.normalizedPhoneCallDisplay.hasValidLatLng
                }
                gpsLocationLatitude={selectedPhoneCall.normalizedPhoneCallDisplay.latFloat}
                gpsLocationLongitude={selectedPhoneCall.normalizedPhoneCallDisplay.lngFloat}
                size={size}
            />
            <PhoneCallInfo
                callerName={selectedPhoneCall.normalizedPhoneCallDisplay.callerName}
                callerPhoneNumber={selectedPhoneCall.normalizedPhoneCallDisplay.callerPhoneNumber}
                classOfServiceText={
                    selectedPhoneCall.normalizedPhoneCallDisplay
                        .classOfServiceAndUncertaintyConfidenceDisplay
                }
                size={size}
            />
        </PanelWrapper>
    );
});
